import React from "react";
import { Page, Text, View, Document, StyleSheet, Image, Font } from '@react-pdf/renderer';
import TMsLogoFull from "../../../assets/LogoStyba.png";

Font.register({
  family: 'Helvetica-Bold',
  fonts: [
    { src: 'https://cdnjs.cloudflare.com/ajax/libs/pdfkit/0.8.3/fonts/Helvetica-Bold.ttf' }
  ]
});

// Estilos
const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#ffffff',
    fontSize: 9,
    paddingBottom: 30, 
  },
  header: {
    textAlign: 'center',
    fontSize: 14,
  },
  logoContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    width: '100%',
    paddingHorizontal: 50,
    paddingTop: 20,
    height: 100, 
  },
  logo: {
    width: 200,
    height: 'auto',
  },
  dateContainer: {
    textAlign: 'right',
    fontSize: 12,
  },
  dateText: {
    fontSize: 15,
    color: 'black',
  },
  timeText: {
    fontSize: 12,
    color: 'black',
    marginTop: 5,
  },
  tableHeader: {
    flexDirection: 'row',
    backgroundColor: '#f2f2f2',
    borderBottomWidth: 1,
    borderBottomColor: '#000',
    padding: 5,
  },
  tableCell: {
    padding: 5,
    width: '10%',
    textAlign: 'center',
    flex: 1,
  },
  tableCellHeader: {
    padding: 5,
    width: '10%',
    textAlign: 'center',
    flex: 1,
    fontFamily: 'Helvetica-Bold'
  },
  tableRow: {
    flexDirection: 'row',
  },
  lastTableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#000',
  },
  contentContainer: {
    marginTop: 10, 
  },
  totalRow: {
    flexDirection: 'row',
    borderTopWidth: 1,
    borderTopColor: '#000',
    marginTop: 5,
    paddingTop: 5,
    justifyContent: 'space-between',
  },
  totalRoutesCell: {
    flex: 1,
    textAlign: 'left',
    fontWeight: 'bold',
  },
  totalLabelCell: {
    textAlign: 'right',
    fontWeight: 'bold',
  },
  totalValueCell: {
    width: '10%',
    textAlign: 'center',
    fontWeight: 'bold',
  },
  pageFooter: {
    position: 'absolute',
    bottom: 10,
    left: 0,
    right: 0,
    textAlign: 'center',
    fontSize: 10,
  },
  tableContainer: {
    marginHorizontal: 40, 
  },
    titleContainer: {
    // flex: 1,
    textAlign: "right",
  },
  title: {
    fontSize: 25,
    fontFamily: 'Helvetica-Bold'
  },
  dateContainer: {
    textAlign: "right",
    fontSize: 12,
    marginTop: 5,
  },
  clientInfoContainer: {
    marginTop: 20, 
    marginLeft: 40, 
    marginTop: 10,
    marginBottom: 20,
    fontSize: 12,
    textAlign: "left",
  },
  boldText: {
    fontFamily: 'Helvetica-Bold',
  },
  containerTable:{
    marginTop: 20,
  },
  containerTitleAndDate:{
    marginTop: 10,
    textAlign: "right",
    display: "flex",
    alignItems: "flex-end",
    flexDirection: "column", 
  }
});

const GeneratePdf = ({ values }) => {
  const currentDate = new Date().toLocaleDateString();
  const currentTime = new Date().toLocaleTimeString();
  const totalMonto = values.data.detail.reduce((sum, item) => sum + item.monto, 0).toFixed(2);
  const totalRoutes = values.data.detail.length;

  return (
    <Document>
      <Page size="A4" style={styles.page} orientation="landscape">

       {/* Header */}
       <View style={styles.logoContainer}fixed>
          <Image src={TMsLogoFull} style={styles.logo} />
          <View style={styles.containerTitleAndDate}>
            <View style={styles.titleContainer}>
              <Text style={styles.title}>Bitácora de Facturación Cliente</Text>
            </View>
            <View style={styles.dateContainer}>
              <Text>
                <Text style={styles.boldText}>Fecha: </Text> {currentDate}
              </Text>
              <Text>
                <Text style={styles.boldText}>Hora: </Text> {currentTime}
              </Text>
            </View>
          </View>
        </View>

        <View style={styles.clientInfoContainer} fixed>
          <Text>
            <Text style={styles.boldText}>Id Factura:</Text> {values.data.billingTranckingId}
          </Text>
          <Text style={{ marginTop: 5 }}>
            <Text style={styles.boldText}>Nombre del Cliente:</Text> {values.data.customerName}
          </Text>
        </View>

        <View style={styles.tableContainer} fixed>
          <View style={styles.tableHeader} fixed>
            <Text style={styles.tableCellHeader}>Fecha</Text>
            <Text style={styles.tableCellHeader}>Id Ruta</Text>
            <Text style={styles.tableCellHeader}>Capacidad</Text>
            <Text style={styles.tableCellHeader}>P. de Carga</Text>
            <Text style={styles.tableCellHeader}>P. de Descarga</Text>
            <Text style={styles.tableCellHeader}>Pts. de Entrega</Text>
            <Text style={styles.tableCellHeader}>Servicio</Text>
            <Text style={styles.tableCellHeader}>Descripción</Text>
            <Text style={styles.tableCellHeader}>Precio</Text>
          </View>
        </View>

        <View style={styles.tableContainer}>
          <View style={styles.contentContainer}>
            {values.data.detail.map((row, index) => 
              row.servicios.map((service, serviceIndex, array) => {
                const isLastRow = index === values.data.detail.length - 1 && serviceIndex === array.length - 1;
                return (
                  <View key={`${index}-${serviceIndex}`} style={styles.tableRow} wrap={false}>
                    <Text style={styles.tableCell}>{row.dateToRoute ? new Date(row.dateToRoute).toISOString().split('T')[0] : 'N/A'}</Text>
                    <Text style={styles.tableCell}>{row.idRoute || 'N/A'}</Text>
                    <Text style={styles.tableCell}>{row.capacidadTonelaje || 'N/A'}</Text>
                    <Text style={styles.tableCell}>{row.puntoCarga || 'N/A'}</Text>
                    <Text style={styles.tableCell}>{row.puntoEntrega || 'N/A'}</Text>
                    <Text style={styles.tableCell}>{row.puntosDeEntregas || 'N/A'}</Text>
                    <Text style={styles.tableCell}>{service.coD_FACTURA || 'Sin Código'}</Text>
                    <Text style={styles.tableCell}>{service.descripcioN_COD || 'Sin Descripción'}</Text>
                    <Text style={styles.tableCell}>{`$${service.price ? service.price.toFixed(2) : '0.00'}`}</Text>
                  </View>
                );
              })
            )}
          </View>
        </View>

        <View style={styles.tableContainer}>
          <View style={{ flexDirection: 'row', borderTopWidth: 1, borderTopColor: '#000', marginTop: 5, paddingTop: 5 }}>
            <Text style={{ flex: 1, textAlign: 'left', fontWeight: 'bold' }}>Total Rutas: {totalRoutes}</Text>
            <Text style={{ textAlign: 'right', fontWeight: 'bold' }}>Total: {`$${parseFloat(totalMonto).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}</Text>
          </View>
        </View>

        <View style={styles.pageFooter} fixed>
          <Text>
            <Text render={({ pageNumber, totalPages }) => `${pageNumber} de ${totalPages}`} />
          </Text>
        </View>

      </Page>
    </Document>
  );
};

export default GeneratePdf;
